// components/LocaleMenu/LocaleMenu.js
import React from 'react';
import classNames from 'classnames';
import { Modal } from '..';
import { useIntl } from 'react-intl';

import englishImage from './flags/english.png';
import thaiImage from './flags/thai.png';

import css from './LocaleMenu.module.css';

const LocaleMenuModal = props => {
  const {
    className,
    rootClassName,
    isOpen,
    onClose,
    currentLocale = 'en',
    onSelectLocale,
    title, // optional override
    onManageDisableScrolling,
  } = props;

  const intl = useIntl();

  const localeOptions = [
    {
      key: 'en',
      label: intl.formatMessage({ id: 'LocaleMenu.englishLabel' }),
      flag: englishImage,
      // optional: also localize alt text separately if you want
      alt: intl.formatMessage({ id: 'LocaleMenu.englishAlt' }),
    },
    {
      key: 'th',
      label: intl.formatMessage({ id: 'LocaleMenu.thaiLabel' }),
      subLabel: intl.formatMessage({ id: 'LocaleMenu.thaiSubLabel' }),
      flag: thaiImage,
      alt: intl.formatMessage({ id: 'LocaleMenu.thaiAlt' }),
    },
  ];

  const modalTitle =
    title ||
    intl.formatMessage({
      id: 'LocaleMenu.title',
    });

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id="LocaleMenuModal"
      className={classes}
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      contentClassName={css.modalContent}
      onManageDisableScrolling={onManageDisableScrolling}
      modalTitle={modalTitle}
      isLocaleModal={true}
    >
      <div className={css.localeList}>
        {localeOptions.map(opt => {
          const isActive = currentLocale === opt.key;

          return (
            <button
              key={opt.key}
              type="button"
              className={classNames(css.localeRow, { [css.activeLocaleRow]: isActive })}
              onClick={() => onSelectLocale(opt.key)}
              aria-label={opt.label}
            >
              <div className={css.localeTextWrapper}>
                <span className={css.flagWrap}>
                  <img className={css.flag} src={opt.flag} alt={opt.alt || opt.label} />
                </span>

                <span className={css.localeText}>
                  <span className={css.localeLabel}>{opt.label}</span>
                  {opt.subLabel ? <span className={css.localeSubLabel}>{opt.subLabel}</span> : null}
                </span>
              </div>

              <span className={css.checkWrap}>
                {isActive
                  ? intl.formatMessage({ id: 'LocaleMenu.selectedCheck' })
                  : ''}
              </span>
            </button>
          );
        })}
      </div>
    </Modal>
  );
};

export default LocaleMenuModal;
